import { createAri } from '@atlassian/jira-platform-ari';
import { type Environment, type CloudId, SOFTWARE } from '@atlassian/jira-shared-types';

import {
	RECAPTCHA_SITE_KEY_DEV,
	RECAPTCHA_SITE_KEY_PROD,
	RECAPTCHA_SITE_KEY_STAGING,
	SUCCESSFUL_INVITE_STATUSES,
} from './constants';
import type { InviteUserResponse } from './types';

export const getJiraSoftwareAri = (cloudId: CloudId): string =>
	createAri({
		resourceOwner: SOFTWARE,
		cloudId: '',
		resourceType: 'site',
		resourceId: cloudId,
	});

export const transformInviteResult = ({
	userId,
	result,
	errorReason,
}: {
	userId: string;
	result: string;
	errorReason: {
		[key: string]: string;
	};
}): InviteUserResponse => {
	if (errorReason && errorReason.message) {
		throw new Error(errorReason.message);
	}
	if (SUCCESSFUL_INVITE_STATUSES.includes(result) === false) {
		throw new Error(`Unsuccessful invite. Response returned result of ${result}`);
	}
	return {
		userId,
		isInviteSuccessful: true,
	};
};

export const getRecaptchaSiteKey = (environment: Environment) => {
	switch (environment) {
		case 'prod':
			return RECAPTCHA_SITE_KEY_PROD;
		case 'staging':
			return RECAPTCHA_SITE_KEY_STAGING;
		default:
			return RECAPTCHA_SITE_KEY_DEV;
	}
};
